import debounce from 'lodash.debounce';
import { toast } from 'react-toastify';
import FavoritesNotification from '../components/FavoritesNotification';

const wait = 1000;
const options = { leading: true, trailing: false };

export const addFavoriteNotification = debounce(
  (): void => {
    toast.dismiss();
    toast(<FavoritesNotification variant="added" />);
  },
  wait,
  options,
);

export const removeFavoriteNotification = debounce(
  (): void => {
    toast.dismiss();
    toast(<FavoritesNotification variant="removed" />);
  },
  wait,
  options,
);

export const restoreFavoriteNotification = debounce(
  (callback: () => void): void => {
    toast.dismiss();
    toast(
      <FavoritesNotification
        variant="restore"
        onClick={callback}
      />,
    );
  },
  wait,
  options,
);

export const favoritesErrorNotification = debounce(
  (): void => {
    toast.dismiss();
    toast(
      <FavoritesNotification variant="error" />,
      {
        type: toast.TYPE.ERROR,
      },
    );
  },
  wait,
  options,
);
